<template>
	<div \id="mwChatWrapper"></div>
</template>

<script>
import Vue from "vue"
import Vuex from "vuex";

export default {
	name: "Chat",
	data: () => {
		return {
			date: false,
			intergramId: "-468342301",
			intergramCustomizations: {
				titleClosed: 'Talk to Us - Live',
				titleOpen: 'Meisterworks Operator',
				introMessage: 'Hi and welcome to the Meisterworks chat! I\'ll get someone to assist you in a moment. Could you please tell me what your query is about?',
				autoResponse: 'Thank you. Let me get a human to assist you right now.',
				autoNoResponse: 'Sorry it\'s taking so long! You won\'t have to wait much longer, but if you prefer you can leave your name, email address and phone number and someone will reach out to you as soon as they are free.',
				mainColor: "#86BD60", // Can be any css supported color 'red', 'rgb(255,87,34)', etc
				// alwaysUseFloatingButton: false // Use the mobile floating button also on large screens
			}    
		}
	},
	computed: {
		...Vuex.mapState({
			user: state => state.auth.user,
			chat: state => state.settings.chat,
		}),
		showChat(){
			if( this.chat.status == "off" ){
				return false
			}
			else{
				if( this.chat.status == "on" ){
					return true;
				}
				else if (this.chat.status == "timed") {
					var time = Vue.moment(this.date).format("HH:mm");
					if( time > this.chat.start && time < this.chat.end ){
						return true;
					}
					else{
						return false;
					}
				}
				else{
					return false;
				}
			}
		}
	},
	watch: {
		user: {
			immediate: true, 
			handler(){
				if( !window.intergramOnOpen ){
					window.intergramOnOpen = {
						visitorName: "visitor"
					}
				}
				if( this.user ){
					window.intergramOnOpen.visitorName = this.user.email; 
				}
			}
		}, 
		showChat: {
			immediate: true, 
			handler(){
				if( this.showChat ){
					this.startChat();
				}
			}
		}
	},
	methods:{
		startChat() {
			var chatScript = document.createElement('script');
			chatScript.setAttribute('src', 'https://www.intergram.xyz/js/widget.js')
			chatScript.setAttribute('id', "intergram");
			window.intergramId = this.intergramId;
			window.intergramCustomizations = this.intergramCustomizations;
			document.body.appendChild(chatScript);
			setTimeout(function() {dispatchEvent(new Event('load'))}, 200);
		}
	},
	created(){
		this.date = new Date();
		this.$store.dispatch("fetchSetting", "chat")
	},
}
</script>